export default __webpack_public_path__ + "static/media/27.fb70bf22.webp";